import { DateRangeInputForm } from 'modules/order/forms';
import { observable, action, makeObservable } from 'mobx';
import { advancedFilterCondition } from 'common/constants';
import moment from 'moment';
import { localStorageHandler } from 'core/services';
import { initialDateFilterOption } from 'common/constants';
import _ from 'lodash';

class OrderDateRangeViewStore {
	@observable selectedDateFilterOption = null;
	@observable customDateRange = false;
	@observable newFilter = true;
	dateFieldName = 'dateCreated';
	dateFormat = 'MM/DD/YYYY';
	queryUtility = null;
	findFunction = {};
	localStorageHandlerKey = null;

	form = new DateRangeInputForm();

	constructor(props) {
		makeObservable(this);
		this.initialize(props);
	}

	@action.bound
	initialize = async ({ queryUtility, findFunction, localStorageHandlerKey }) => {
		Object.assign(this, {
			queryUtility,
			findFunction,
			localStorageHandlerKey,
		});
		this.selectedDateFilterOption = localStorageHandler.get(localStorageHandlerKey) || initialDateFilterOption;
		await this.onDateSelect(this.selectedDateFilterOption);
	};

	@action.bound
	closeCustomDateRange = () => {
		this.customDateRange = false;
		this.selectedDateFilterOption = localStorageHandler.get(this.localStorageHandlerKey) || initialDateFilterOption;
	};

	@action.bound
	onDateSelect = async selectedValue => {
		this.selectedDateFilterOption = selectedValue || initialDateFilterOption;
		if (this.selectedDateFilterOption.value == 'None') {
			return;
		}
		let dateBegin = new Date();
		let dateEnd = Date.now();
		this.customDateRange = false;
		switch (this.selectedDateFilterOption.value) {
			case 'last30Days':
				dateBegin.setDate(dateBegin.getDate() - 30);
				break;
			case 'last90Days':
				dateBegin.setDate(dateBegin.getDate() - 90);
				break;
			case 'last180Days':
				dateBegin.setDate(dateBegin.getDate() - 180);
				break;
			case 'last365Days':
				dateBegin.setDate(dateBegin.getDate() - 365);
				break;
			case 'custom':
				this.customDateRange = true;
				break;
		}
		if (!this.customDateRange) {
			this.populateDateFilter(dateBegin, dateEnd);
		} else if (this.newFilter) {
			this.populateDateFilter(...Object.values(localStorageHandler.get('custom-date-range')));
			this.customDateRange = false;
		}
		this.newFilter = false;
	};

	@action.bound
	populateDateFilter = async (dateBegin, dateEnd) => {
		const rangeStartFilterElement = {
			condition: advancedFilterCondition.GreaterEqual,
			fieldName: this.dateFieldName,
			filterValue: [{ value: moment(dateBegin).format('YYYY/MM/DD') }],
		};
		const rangeEndFilterElement = {
			condition: advancedFilterCondition.LesserEqual,
			fieldName: this.dateFieldName,
			filterValue: [{ value: moment(dateEnd).format('YYYY/MM/DD') }],
		};
		_.remove(this.queryUtility.filter.advancedSearch, { fieldName: this.dateFieldName });
		if (!this.queryUtility.filter.advancedSearch) {
			this.queryUtility.filter.advancedSearch = [];
		}
		this.queryUtility.filter.advancedSearch.push(rangeStartFilterElement);
		this.queryUtility.filter.advancedSearch.push(rangeEndFilterElement);
		localStorageHandler.set(this.localStorageHandlerKey, this.selectedDateFilterOption);
		await this.findFunction();
	};

	@action.bound
	onDateInput = async () => {
		this.populateDateFilter(this.form.$('dateRangeStart').value, this.form.$('dateRangeEnd').value);
		localStorageHandler.set('custom-date-range', {
			dateRangeStart: this.form.$('dateRangeStart').value,
			dateRangeEnd: this.form.$('dateRangeEnd').value,
		});
		this.customDateRange = false;
	};

	@action.bound
	todayFilterChange = checked => {
		this.resetFilter(checked, false);
	};

	@action.bound
	resetFilter = (hideFilter = true, setToNull = false) => {
		if (setToNull) {
			this.selectedDateFilterOption = { value: 'None' };
			localStorageHandler.set(this.localStorageHandlerKey, { value: 'None' });
		}
		hideFilter
			? _.remove(this.queryUtility.filter.advancedSearch, { fieldName: this.dateFieldName })
			: this.selectedDateFilterOption.value != 'custom'
			? this.onDateSelect(this.selectedDateFilterOption.value != 'None' ? this.selectedDateFilterOption : null)
			: this.onDateInput();
	};
}

export default OrderDateRangeViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/OrderDateRangeViewStore.js